window.addEventListener("DOMContentLoaded", () => {
  //const d1apiurl = "https://9ddd-2607-fa49-7443-b700-a8a5-63d2-692c-c245.ngrok-free.app"
  const d1apiurl = "https://stbruno.bridge.district1.ca"

  let allValidated = false;
  let itemsBooked = [];
  var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
      console.log('cart content', data);
      //itemsBooked = data.items.filter( item => item.properties._is_booking === '1' && (item.properties._salle || item.properties._service_id))
      itemsBooked = data.items.filter( item => item.properties._is_booking === '1' && (item.properties._salle || item.properties._service_id || item.properties._timeslot))
      if (itemsBooked.length > 0) {
        // On va vérifier avant de permettre de faire le checkout
        $("#CartPageForm").on('submit', function(event) {
          if (!allValidated) {
            event.preventDefault();
            validateItems().then( (resp) => {
              if (resp.filter( r => r === false).length) {
                // Il y a des non-disponibilités!!!!
                itemsBooked.forEach( item => {
                  if (item.estDisponible === false) {
                    $(`div.cart__item[data-key="${item.key}"] > .cart__item-details`).append("<p>DÉSOLÉ, CE PRODUIT N'EST PLUS DISPONIBLE SELON VOS CRITÈRES.<br>VEUILLEZ LE RETIRER DU PANIER ET FAIRE UNE NOUVELLE RÉSERVATION</p>")
                    $(`div.cart__item[data-key="${item.key}"]`).addClass('errors');
                  }
                })
              } else {
                allValidated = true;
                $("[name='checkout']").click();
              }
            })
            return false; 
          }
        });

        // Valider à l'entrée du cart
        validateItems().then( (resp) => {
            if (resp.filter( r => r === false).length) {
              // Il y a des non-disponibilités!!!!
              itemsBooked.forEach( item => {
                if (item.estDisponible === false) {
                  $(`div.cart__item[data-key="${item.key}"] > .cart__item-details`).append("<p>DÉSOLÉ, CE PRODUIT N'EST PLUS DISPONIBLE SELON VOS CRITÈRES.<br>VEUILLEZ LE RETIRER DU PANIER ET FAIRE UNE NOUVELLE RÉSERVATION</p>")
                  $(`div.cart__item[data-key="${item.key}"]`).addClass('errors');
                }
              })
            }
          })
      }
      return data
    });


  // Retourner un Promise si OK ou non
  function validateItems() {
    return new Promise( (resolve, reject) => {
      $("[name='checkout']").attr('disabled','disabled');
      let p = [];
      itemsBooked.forEach( item => {
        let info = item.properties?._salle ? JSON.parse(item.properties?._salle) : undefined;
        let ressource = item.properties?._ressource ? JSON.parse(item.properties?._ressource) : undefined;
        let timeslots = item.properties?._timeslot || [];
        let overbooked = +item.properties?._overbooked || 0;

        // On fait les salles + ressources
        if (info || ressource) {
          p.push(new Promise( 
            (resolve, reject) => {
              let request = new XMLHttpRequest();
              request.item = item;
              if (info) {
                request.open("GET", d1apiurl + `/widgets/salles/validate?date=${info.salleTemps}&salleid=${info.salleSalleid}&duree=${info.salleDuree}`);
                request.send();
              } else if (ressource) {
                request.open("POST", d1apiurl + `/api/bookings/ListSlots`);
                request.setRequestHeader('Content-type', 'application/json');
                const endDate = (new Date(ressource.ressourceTemps))
                endDate.setMinutes(endDate.getMinutes() + +ressource.ressourceDuree);
                var params = {
                    "service_id" : item.properties._service_id,
                    "start" : ressource.ressourceTemps,
                    "end" : ressource.ressourceTemps,
                    "duration" : +ressource.ressourceDuree,
                    "num" : 1
                }
                request.send(JSON.stringify(params));
              }
  
              request.onload = function() {
                try {
                  if (this.status === 404 || this.status === 422) {
                    resolve(false);
                  } else {
                    var l = JSON.parse(this.response);
                    if (info) {
                      // ATTENTION, on pourrait avoir une salle disponible mais pas les parties, aucune garantie de l'ordre de retour des HTTP
                      // Alors on ne force pas le vrai/faux mais on valide avant
                      if (this.item.estDisponible !== false) {
                        this.item.estDisponible = l;
                      }
                      resolve(this.item.estDisponible);
                    } else {
                      const ress = l.find( r => r.start_sec === ressource.ressourceTemps)
                      this.item.estDisponible = (ress?.availability_count||0) > 1;
                      resolve(this.item.estDisponible);
                    }
                  }
                } catch(error) {
                  console.error(error);
                  alert('Une erreur est survenue et il nous est impossible de vérifier les disponibilités. Veuillez essayer plus tard.');
                  reject(error);
                }
              }
            })
          )
        }

        // Vérifier pour les parties
        if (timeslots.length > 0) {
          p.push(new Promise( 
            (resolve, reject) => {
              let request = new XMLHttpRequest();
              request.item = item;
              // Valider les parties
              request.open("GET", d1apiurl + `/widgets/games/validate?date=${item.properties['Date désirée']}&overbooked=${overbooked}&qte=${item.quantity}&${timeslots.map( s => `timeslots[]=${s}` ).join('&')}`);
              request.send();
              request.onload = function() {
                try {
                  if (this.status === 404 || this.status === 422) {
                    resolve(false);
                  } else {
                    var l = JSON.parse(this.response);
                    if (this.item.estDisponible !== false) {
                      this.item.estDisponible = l;
                    }
                    resolve(this.item.estDisponible);
                  }
                } catch(error) {
                  console.error(error);
                  alert('Une erreur est survenue et il nous est impossible de vérifier les disponibilités. Veuillez essayer plus tard.');
                  reject(error);
                }
              }
            })
          )
        }
      }) 
      Promise.all(p).then( (allDone) => {
        resolve(allDone);
        if (allDone.filter( r => r === false).length) {
          // On désactive le CHECKOUT
          $("[name='checkout']").attr('disabled','disabled')
        } else {
          $("[name='checkout']").removeAttr('disabled');
        }
      }, reject);
    });
  }


  
});